import React, { useState, memo } from 'react';
import { ChevronDownIcon, SparklesIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function ProofAndFAQ() {
  const {
    ref: proofRef,
    isVisible: proofVisible
  } = useScrollReveal();
  const {
    ref: faqRef,
    isVisible: faqVisible
  } = useScrollReveal();
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    q: '¿Funciona si tengo mucha ansiedad?',
    a: 'Sí, el método está diseñado precisamente para momentos de alta carga mental.'
  }, {
    q: '¿Necesito comprar algo más?',
    a: 'No, solo un cuaderno, un bolígrafo y 10 minutos de tu tiempo.'
  }, {
    q: '¿Es difícil de aprender?',
    a: 'Es tan simple que puedes memorizarlo en la primera lectura.'
  }];
  return <section className="relative py-24 px-6 z-10 bg-night-900" data-id="element-200">
      <div className="max-w-3xl mx-auto" data-id="element-201">
        {/* Proof / Believability */}
        <div ref={proofRef} className={`mb-24 glass-card p-8 md:p-12 rounded-2xl border-l-4 border-l-gold-500 section-reveal ${proofVisible ? 'visible' : ''}`} data-id="element-202">
          <SparklesIcon className="w-8 h-8 text-gold-400 mb-6" data-id="element-203" />
          <p className="text-xl md:text-2xl text-cream-100 font-heading leading-relaxed italic" data-id="element-204">
            "En los primeros 7 días de aplicar el Método S.C.A., notarás que el
            tiempo que pasas dando vueltas en la cama disminuye drásticamente.
            No es una promesa mágica; es el resultado de bajar tus niveles de
            cortisol antes de tocar la almohada."
          </p>
        </div>

        {/* FAQ */}
        <div ref={faqRef} className={`section-reveal ${faqVisible ? 'visible' : ''}`} data-id="element-205">
          <h3 className="text-3xl font-heading font-bold text-cream-100 mb-10 text-center" data-id="element-206">
            Preguntas Frecuentes
          </h3>

          <div className="space-y-4" data-id="element-207">
            {faqs.map((faq, index) => <div key={index} className="glass-card rounded-xl overflow-hidden transition-all duration-300" data-id="element-208">
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500" aria-expanded={openFaq === index} data-id="element-209">
                  <span className="text-lg font-heading font-semibold text-cream-100 pr-4" data-id="element-210">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-gold-400 flex-shrink-0 transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-211" />
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openFaq === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-212">
                  <p className="text-cream-200 text-lg" data-id="element-213">{faq.a}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}